<div class="flex gap-1">
  @for (reference of references; track reference) {
    <a
      class="rounded overflow-hidden h-8 w-8 relative flex-none shadow-button"
      [ngClass]="dark ? 'border-dark border-opacity-80' : 'border-white'"
      routerLinkActive="border-2"
      [routerLink]="['/project-references', reference.id]"
      [replaceUrl]="true"
      [queryParamsHandling]="'preserve'">
      <vwui-tooltip class="absolute inset-0 vwui-tooltip--inline" [label]="reference.name || ''" position="bottom" [offset]="6">
        <app-photo class="w-full h-full rounded" [photo]="reference.primaryPhoto" sizes="32px"></app-photo>
      </vwui-tooltip>
    </a>
  }
</div>
